<template>
  <div
    v-if="!$route.query.portfolioId || !hasPortfolioInAccount"
    class="flex h-full w-full flex-col items-center justify-center space-y-10 text-center"
  >
    <i v-html="$icons.noPermission"></i>
    <p class="text-3xl leading-snug text-gray-300">Você não tem permissão para<br />visualizar essa estratégia.</p>
  </div>
  <div v-else class="relative flex h-full flex-col">
    <div
      class="flex w-full items-center justify-start space-x-6 border-b-2 border-b-ontick-graphite-500 bg-ontick-carbon-600 py-2 px-3"
    >
      <div v-if="$route.query.portfolioId && Object.keys(strategies).length > 0" class="block w-[40%] lg:w-[30%]">
        <portfolio-chart-header-component
          @listInvestment="listInvestment"
          :data="strategies"
        ></portfolio-chart-header-component>
      </div>

      <div class="flex items-center justify-center space-x-1">
        <!-- <p class="text-xs font-medium text-ontick-steel-400 mr-1">Grade:</p> -->
        <!-- 1 gráfico -->
        <button class="rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md" @click="template = 1">
          <!-- Grid 1 -->
          <div class="flex flex-row space-x-0.5 rounded">
            <div
              :class="[
                template === 1 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                'h-[16px] w-[16px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
          </div>
        </button>
        <!-- 2 gráficos dividido horizontalmente na tela -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 2"
        >
          <!-- Grid 2 -->
          <div class="flex flex-row space-x-0.5 rounded">
            <div
              :class="[
                template === 2 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[16px] w-[8px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
            <div
              :class="[
                template === 2 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[16px] w-[8px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
          </div>
        </button>
        <!-- 2 gráficos dividido verticalmente na tela -->
        <button class="rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md" @click="template = 8">
          <!-- Grid 8 -->
          <div class="flex flex-col space-y-0.5 rounded">
            <div
              :class="[
                template === 8 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[7.25px] w-[16px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
            <div
              :class="[
                template === 8 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[7.25px] w-[16px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
          </div>
        </button>
        <!-- 3 gráficos - 1 esquerdo e 2 direito verticalmente -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 3"
        >
          <!-- Grid 3 -->
          <div class="flex flex-col space-y-0.5 rounded">
            <div
              :class="[
                template === 3 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[7.25px] w-full rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
            <div class="flex h-full flex-row space-x-0.5">
              <div
                :class="[
                  template === 3 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  ,
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 3 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  ,
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
          </div>
        </button>
        <!-- 3 gráficos - 1 direito e 2 esquerdo verticalmente -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 4"
        >
          <!-- Grid 4 -->
          <div class="flex flex-col space-y-0.5 rounded">
            <div class="flex h-full flex-row space-x-0.5">
              <div
                :class="[
                  template === 4 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 4 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
            <div
              :class="[
                template === 4 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                'h-[7.25px] w-full rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
          </div>
        </button>
        <!-- 3 gráficos - 1 esquerdo e 2 direito -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 5"
        >
          <!-- Grid 5 -->
          <div class="flex flex-row space-x-0.5 rounded">
            <div
              :class="[
                template === 5 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                ,
                'h-[16px] w-[8px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
            <div class="flex h-full flex-col space-y-0.5">
              <div
                :class="[
                  template === 5 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 5 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
          </div>
        </button>
        <!-- 3 gráficos - 2 esquerdo e 1 direito -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 6"
        >
          <!-- Grid 6 -->
          <div class="flex flex-row space-x-0.5 rounded">
            <div class="flex h-full flex-col space-y-0.5">
              <div
                :class="[
                  template === 6 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 6 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
            <div
              :class="[
                template === 6 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                'h-[16px] w-[8px] rounded-[2px] border-[2px]',
              ]"
            >
              &nbsp;
            </div>
          </div>
        </button>
        <!-- 4 gráficos -->
        <button
          class="hidden rounded bg-ontick-graphite-500 p-1.5 text-sm font-medium shadow-md md:block"
          @click="template = 7"
        >
          <!-- Grid 7 -->
          <div class="flex flex-col space-y-0.5 rounded">
            <div class="flex h-full flex-row space-x-0.5">
              <div
                :class="[
                  template === 7 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 7 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
            <div class="flex h-full flex-row space-x-0.5">
              <div
                :class="[
                  template === 7 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
              <div
                :class="[
                  template === 7 ? 'border-ontick-blue-500' : 'border-ontick-graphite-400',
                  'h-[7.25px] w-[8px] rounded-[2px] border-[2px]',
                ]"
              >
                &nbsp;
              </div>
            </div>
          </div>
        </button>

        <!-- <div class="block">
          <p class="text-xs"><strong>paramChart01:</strong> {{ JSON.stringify(paramChart01) }}</p>
          <p class="text-xs"><strong>paramChart02:</strong> {{ JSON.stringify(paramChart02) }}</p>
        </div> -->
      </div>

      <!-- <button
        @click="updateAllMarkers()"
        content="Atualizar dados"
        v-tippy="{ arrow: true, theme: 'green' }"
        class="relative col-span-1 ml-2 hidden w-10 items-center py-2 text-ontick-blue-500 md:inline-flex md:px-2"
      >
        <span v-html="btnUpdateMarkers ? updateIcon.active : updateIcon.disabled"></span>
      </button>

      <!-- Habilitar somente em "localhost" -->
      <!-- <button
        @click="debugDatafeedInLocalhost()"
        class="bg-[#7c3aed] px-3 py-1.5 rounded-md text-xs font-bold text-white"
      >
        Debug Datafeed
      </button> -->
    </div>

    <template v-if="template === 1">
      <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-y-2 divide-ontick-graphite-500">
        <div class="relative flex h-full w-full items-center justify-center">
          <adjustment-chart-component
            :visible="paramChart01.toggleConfig"
            @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
            @click-outside="paramChart01.toggleConfig = false"
          >
            <div class="flex flex-col space-x-0 space-y-2">
              <portfolio-strategy-chart-header-component
                @listInvestment="listInvestmentStrategy($event, 'paramChart01')"
                :select_investment_id="paramChart01.investmentId"
                :data="portfolioStrategies"
              ></portfolio-strategy-chart-header-component>
              <div class="flex space-x-2">
                <ontick-editable-select-component
                  inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                  maxHeight="max-h-96"
                  :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                  :value="paramChart01.searchTicker"
                  :acceptInput="true"
                  name="symbol"
                  @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                  @selected-from-box="changeSymbol($event, 'paramChart01')"
                  @clear_field="clearField('paramChart01')"
                  @close="paramChart01.searchTicker = paramChart01.ticker"
                />
                <portfolio-select-timeframe-component
                  v-if="Object.keys(paramChart01).length > 0"
                  :ticker="paramChart01.ticker"
                  :timeframe="paramChart01.timeframe"
                  @change="changeTimeframe($event, 'paramChart01')"
                />
              </div>
            </div>
          </adjustment-chart-component>
          <portfolio-chart-grid-component
            :ticker="paramChart01.ticker"
            :timeframe="paramChart01.timeframe"
            :investmentId="paramChart01.investmentId"
            @contextUuid="setContextUuid($event, 'paramChart01')"
            :selectedStrategy="paramChart01.selectedStrategy"
          />
        </div>
      </div>
    </template>

    <template v-if="template === 2">
      <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-ontick-graphite-500">
        <div class="relative flex h-full w-full items-center justify-center">
          <adjustment-chart-component
            :visible="paramChart01.toggleConfig"
            @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
            @click-outside="paramChart01.toggleConfig = false"
          >
            <div class="flex flex-col space-x-0 space-y-2">
              <portfolio-strategy-chart-header-component
                @listInvestment="listInvestmentStrategy($event, 'paramChart01')"
                :select_investment_id="paramChart01.investmentId"
                :data="portfolioStrategies"
              ></portfolio-strategy-chart-header-component>
              <div class="flex space-x-2">
                <ontick-editable-select-component
                  inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                  maxHeight="max-h-96"
                  :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                  :value="paramChart01.searchTicker"
                  :acceptInput="true"
                  name="symbol"
                  @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                  @selected-from-box="changeSymbol($event, 'paramChart01')"
                  @clear_field="clearField('paramChart01')"
                  @close="paramChart01.searchTicker = paramChart01.ticker"
                />
                <portfolio-select-timeframe-component
                  :ticker="paramChart01.ticker"
                  :timeframe="paramChart01.timeframe"
                  @change="changeTimeframe($event, 'paramChart01')"
                />
              </div>
            </div>
          </adjustment-chart-component>

          <portfolio-chart-grid-component
            v-if="Object.keys(paramChart01).length > 0"
            :ticker="paramChart01.ticker"
            :timeframe="paramChart01.timeframe"
            :investmentId="paramChart01.investmentId"
            @contextUuid="setContextUuid($event, 'paramChart01')"
            :selectedStrategy="paramChart01.selectedStrategy"
          />
        </div>
        <div class="relative flex h-full w-full items-center justify-center">
          <adjustment-chart-component
            :visible="paramChart02.toggleConfig"
            @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
            @click-outside="paramChart02.toggleConfig = false"
          >
            <div class="flex flex-col space-x-0 space-y-2">
              <portfolio-strategy-chart-header-component
                @listInvestment="listInvestmentStrategy($event, 'paramChart02')"
                :select_investment_id="paramChart02.investmentId"
                :data="portfolioStrategies"
              ></portfolio-strategy-chart-header-component>
              <div class="flex space-x-2">
                <ontick-editable-select-component
                  inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                  maxHeight="max-h-96"
                  :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                  :value="paramChart02.searchTicker"
                  :acceptInput="true"
                  name="symbol"
                  @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                  @selected-from-box="changeSymbol($event, 'paramChart02')"
                  @clear_field="clearField('paramChart02')"
                  @close="paramChart02.searchTicker = paramChart02.ticker"
                />
                <portfolio-select-timeframe-component
                  :ticker="paramChart02.ticker"
                  :timeframe="paramChart02.timeframe"
                  @change="changeTimeframe($event, 'paramChart02')"
                />
              </div>
            </div>
          </adjustment-chart-component>

          <portfolio-chart-grid-component
            v-if="Object.keys(paramChart02).length > 0"
            :ticker="paramChart02.ticker"
            :timeframe="paramChart02.timeframe"
            :investmentId="paramChart02.investmentId"
            @contextUuid="setContextUuid($event, 'paramChart02')"
            :selectedStrategy="paramChart02.selectedStrategy"
          />
        </div>
      </div>
    </template>

    <template v-if="template === 8">
      <div v-if="hasParamChart" class="flex h-full flex-col divide-y-2 divide-ontick-graphite-500">
        <div class="relative flex h-full w-full items-center justify-center">
          <adjustment-chart-component
            :visible="paramChart01.toggleConfig"
            @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
            @click-outside="paramChart01.toggleConfig = false"
          >
            <div class="flex flex-col space-x-0 space-y-2">
              <portfolio-strategy-chart-header-component
                @listInvestment="listInvestmentStrategy($event, 'paramChart01')"
                :select_investment_id="paramChart01.investmentId"
                :data="portfolioStrategies"
              ></portfolio-strategy-chart-header-component>
              <div class="flex space-x-2">
                <ontick-editable-select-component
                  inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                  maxHeight="max-h-96"
                  :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                  :value="paramChart01.searchTicker"
                  :acceptInput="true"
                  name="symbol"
                  @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                  @selected-from-box="changeSymbol($event, 'paramChart01')"
                  @clear_field="clearField('paramChart01')"
                  @close="paramChart01.searchTicker = paramChart01.ticker"
                />
                <portfolio-select-timeframe-component
                  :ticker="paramChart01.ticker"
                  :timeframe="paramChart01.timeframe"
                  @change="changeTimeframe($event, 'paramChart01')"
                />
              </div>
            </div>
          </adjustment-chart-component>

          <portfolio-chart-grid-component
            v-if="Object.keys(paramChart01).length > 0"
            :ticker="paramChart01.ticker"
            :timeframe="paramChart01.timeframe"
            :investmentId="paramChart01.investmentId"
            @contextUuid="setContextUuid($event, 'paramChart01')"
            :selectedStrategy="paramChart01.selectedStrategy"
          />
        </div>
        <div class="relative flex h-full w-full items-center justify-center">
          <adjustment-chart-component
            :visible="paramChart02.toggleConfig"
            @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
            @click-outside="paramChart02.toggleConfig = false"
          >
            <div class="flex flex-col space-x-0 space-y-2">
              <portfolio-strategy-chart-header-component
                @listInvestment="listInvestmentStrategy($event, 'paramChart02')"
                :select_investment_id="paramChart02.investmentId"
                :data="portfolioStrategies"
              ></portfolio-strategy-chart-header-component>
              <div class="flex space-x-2">
                <ontick-editable-select-component
                  inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                  maxHeight="max-h-96"
                  :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                  :value="paramChart02.searchTicker"
                  :acceptInput="true"
                  name="symbol"
                  @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                  @selected-from-box="changeSymbol($event, 'paramChart02')"
                  @clear_field="clearField('paramChart02')"
                  @close="paramChart02.searchTicker = paramChart02.ticker"
                />
                <portfolio-select-timeframe-component
                  :ticker="paramChart02.ticker"
                  :timeframe="paramChart02.timeframe"
                  @change="changeTimeframe($event, 'paramChart02')"
                />
              </div>
            </div>
          </adjustment-chart-component>

          <portfolio-chart-grid-component
            v-if="Object.keys(paramChart02).length > 0"
            :ticker="paramChart02.ticker"
            :timeframe="paramChart02.timeframe"
            :investmentId="paramChart02.investmentId"
            @contextUuid="setContextUuid($event, 'paramChart02')"
            :selectedStrategy="paramChart02.selectedStrategy"
          />
        </div>
      </div>
    </template>

    <template v-if="template === 3">
      <div class="flex h-full w-full flex-col divide-y-2 divide-ontick-graphite-500">
        <div v-if="hasParamChart" class="flex h-full">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart01.toggleConfig"
              @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
              @click-outside="paramChart01.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart01')"
                  :select_investment_id="paramChart01.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart01.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart01')"
                    @clear_field="clearField('paramChart01')"
                    @close="paramChart01.searchTicker = paramChart01.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart01.ticker"
                    :timeframe="paramChart01.timeframe"
                    @change="changeTimeframe($event, 'paramChart01')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              :investmentId="paramChart01.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart01')"
              :selectedStrategy="paramChart01.selectedStrategy"
            />
          </div>
        </div>
        <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart02.toggleConfig"
              @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
              @click-outside="paramChart02.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart02')"
                  :select_investment_id="paramChart02.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart02.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart02')"
                    @clear_field="clearField('paramChart02')"
                    @close="paramChart02.searchTicker = paramChart02.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart02.ticker"
                    :timeframe="paramChart02.timeframe"
                    @change="changeTimeframe($event, 'paramChart02')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              :investmentId="paramChart02.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart02')"
              :selectedStrategy="paramChart02.selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart03.toggleConfig"
              @change="paramChart03.toggleConfig = !paramChart03.toggleConfig"
              @click-outside="paramChart03.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart03')"
                  :select_investment_id="paramChart03.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart03.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart03.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart03')"
                    @clear_field="clearField('paramChart03')"
                    @close="paramChart03.searchTicker = paramChart03.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart03.ticker"
                    :timeframe="paramChart03.timeframe"
                    @change="changeTimeframe($event, 'paramChart03')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart03.ticker"
              :timeframe="paramChart03.timeframe"
              :investmentId="paramChart03.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart03')"
              :selectedStrategy="paramChart03.selectedStrategy"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="template === 4">
      <div class="flex h-full w-full flex-col divide-y-2 divide-ontick-graphite-500">
        <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart01.toggleConfig"
              @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
              @click-outside="paramChart01.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart01')"
                  :select_investment_id="paramChart01.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart01.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart01')"
                    @clear_field="clearField('paramChart01')"
                    @close="paramChart01.searchTicker = paramChart01.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart01.ticker"
                    :timeframe="paramChart01.timeframe"
                    @change="changeTimeframe($event, 'paramChart01')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              :investmentId="paramChart01.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart01')"
              :selectedStrategy="paramChart01.selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart02.toggleConfig"
              @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
              @click-outside="paramChart02.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart02')"
                  :select_investment_id="paramChart02.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart02.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart02')"
                    @clear_field="clearField('paramChart02')"
                    @close="paramChart02.searchTicker = paramChart02.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart02.ticker"
                    :timeframe="paramChart02.timeframe"
                    @change="changeTimeframe($event, 'paramChart02')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              :investmentId="paramChart02.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart02')"
              :selectedStrategy="paramChart02.selectedStrategy"
            />
          </div>
        </div>
        <div v-if="hasParamChart" class="flex h-full">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart03.toggleConfig"
              @change="paramChart03.toggleConfig = !paramChart03.toggleConfig"
              @click-outside="paramChart03.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart03')"
                  :select_investment_id="paramChart03.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart03.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart03.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart03')"
                    @clear_field="clearField('paramChart03')"
                    @close="paramChart03.searchTicker = paramChart03.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart03.ticker"
                    :timeframe="paramChart03.timeframe"
                    @change="changeTimeframe($event, 'paramChart03')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart03.ticker"
              :timeframe="paramChart03.timeframe"
              :investmentId="paramChart03.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart03')"
              :selectedStrategy="paramChart03.selectedStrategy"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="template === 5">
      <div v-if="hasParamChart" class="flex h-full w-full flex-row divide-x-2 divide-ontick-graphite-500">
        <div class="flex w-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart01.toggleConfig"
              @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
              @click-outside="paramChart01.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart01')"
                  :select_investment_id="paramChart01.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart01.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart01')"
                    @clear_field="clearField('paramChart01')"
                    @close="paramChart01.searchTicker = paramChart01.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart01.ticker"
                    :timeframe="paramChart01.timeframe"
                    @change="changeTimeframe($event, 'paramChart01')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              :investmentId="paramChart01.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart01')"
              :selectedStrategy="paramChart01.selectedStrategy"
            />
          </div>
        </div>
        <div class="flex h-full w-full flex-col divide-y-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart02.toggleConfig"
              @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
              @click-outside="paramChart02.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart02')"
                  :select_investment_id="paramChart02.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart02.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart02')"
                    @clear_field="clearField('paramChart02')"
                    @close="paramChart02.searchTicker = paramChart02.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart02.ticker"
                    :timeframe="paramChart02.timeframe"
                    @change="changeTimeframe($event, 'paramChart02')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              :investmentId="paramChart02.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart02')"
              :selectedStrategy="paramChart02.selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart03.toggleConfig"
              @change="paramChart03.toggleConfig = !paramChart03.toggleConfig"
              @click-outside="paramChart03.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart03')"
                  :select_investment_id="paramChart03.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart03.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart03.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart03')"
                    @clear_field="clearField('paramChart03')"
                    @close="paramChart03.searchTicker = paramChart03.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart03.ticker"
                    :timeframe="paramChart03.timeframe"
                    @change="changeTimeframe($event, 'paramChart03')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart03.ticker"
              :timeframe="paramChart03.timeframe"
              :investmentId="paramChart03.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart03')"
              :selectedStrategy="paramChart03.selectedStrategy"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="template === 6">
      <div v-if="hasParamChart" class="flex h-full w-full flex-row divide-x-2 divide-ontick-graphite-500">
        <div class="flex h-full w-full flex-col divide-y-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart01.toggleConfig"
              @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
              @click-outside="paramChart01.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart01')"
                  :select_investment_id="paramChart01.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart01.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart01')"
                    @clear_field="clearField('paramChart01')"
                    @close="paramChart01.searchTicker = paramChart01.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart01.ticker"
                    :timeframe="paramChart01.timeframe"
                    @change="changeTimeframe($event, 'paramChart01')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              :investmentId="paramChart01.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart01')"
              :selectedStrategy="paramChart01.selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart02.toggleConfig"
              @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
              @click-outside="paramChart02.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart02')"
                  :select_investment_id="paramChart02.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart02.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart02')"
                    @clear_field="clearField('paramChart02')"
                    @close="paramChart02.searchTicker = paramChart02.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart02.ticker"
                    :timeframe="paramChart02.timeframe"
                    @change="changeTimeframe($event, 'paramChart02')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              :investmentId="paramChart02.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart02')"
              :selectedStrategy="paramChart02.selectedStrategy"
            />
          </div>
        </div>
        <div class="flex w-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart03.toggleConfig"
              @change="paramChart03.toggleConfig = !paramChart03.toggleConfig"
              @click-outside="paramChart03.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart03')"
                  :select_investment_id="paramChart03.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart03.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart03.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart03')"
                    @clear_field="clearField('paramChart03')"
                    @close="paramChart03.searchTicker = paramChart03.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart03.ticker"
                    :timeframe="paramChart03.timeframe"
                    @change="changeTimeframe($event, 'paramChart03')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart03.ticker"
              :timeframe="paramChart03.timeframe"
              :investmentId="paramChart03.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart03')"
              :selectedStrategy="paramChart03.selectedStrategy"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="template === 7">
      <div class="flex h-full w-full flex-col divide-y-2 divide-ontick-graphite-500">
        <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart01.toggleConfig"
              @change="paramChart01.toggleConfig = !paramChart01.toggleConfig"
              @click-outside="paramChart01.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart01')"
                  :select_investment_id="paramChart01.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart01.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart01.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart01')"
                    @clear_field="clearField('paramChart01')"
                    @close="paramChart01.searchTicker = paramChart01.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart01.ticker"
                    :timeframe="paramChart01.timeframe"
                    @change="changeTimeframe($event, 'paramChart01')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart01.ticker"
              :timeframe="paramChart01.timeframe"
              :investmentId="paramChart01.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart01')"
              :selectedStrategy="paramChart01.selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart02.toggleConfig"
              @change="paramChart02.toggleConfig = !paramChart02.toggleConfig"
              @click-outside="paramChart02.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart02')"
                  :select_investment_id="paramChart02.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart02.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart02.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart02')"
                    @clear_field="clearField('paramChart02')"
                    @close="paramChart02.searchTicker = paramChart02.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart02.ticker"
                    :timeframe="paramChart02.timeframe"
                    @change="changeTimeframe($event, 'paramChart02')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart02.ticker"
              :timeframe="paramChart02.timeframe"
              :investmentId="paramChart02.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart02')"
              :selectedStrategy="paramChart02.selectedStrategy"
            />
          </div>
        </div>
        <div v-if="hasParamChart" class="flex h-full divide-x-2 divide-ontick-graphite-500">
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart03.toggleConfig"
              @change="paramChart03.toggleConfig = !paramChart03.toggleConfig"
              @click-outside="paramChart03.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart03')"
                  :select_investment_id="paramChart03.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart03.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart03.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart03')"
                    @clear_field="clearField('paramChart03')"
                    @close="paramChart03.searchTicker = paramChart03.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart03.ticker"
                    :timeframe="paramChart03.timeframe"
                    @change="changeTimeframe($event, 'paramChart03')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart03.ticker"
              :timeframe="paramChart03.timeframe"
              :investmentId="paramChart03.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart03')"
              :selectedStrategy="paramChart03.selectedStrategy"
            />
          </div>
          <div class="relative flex h-full w-full items-center justify-center">
            <adjustment-chart-component
              :visible="paramChart04.toggleConfig"
              @change="paramChart04.toggleConfig = !paramChart04.toggleConfig"
              @click-outside="paramChart04.toggleConfig = false"
            >
              <div class="flex flex-col space-x-0 space-y-2">
                <portfolio-strategy-chart-header-component
                  @listInvestment="listInvestmentStrategy($event, 'paramChart04')"
                  :select_investment_id="paramChart04.investmentId"
                  :data="portfolioStrategies"
                ></portfolio-strategy-chart-header-component>
                <div class="flex space-x-2">
                  <ontick-editable-select-component
                    inputStyles="!ring-0 !border-ontick-carbon-500 !focus:border-ontick-carbon-500 bg-ontick-graphite-500 rounded text-sm font-medium h-10 w-[200px]"
                    maxHeight="max-h-96"
                    :options="availableSymbols.map((symbol) => ({ label: symbol, value: symbol }))"
                    :value="paramChart04.searchTicker"
                    :acceptInput="true"
                    name="symbol"
                    @input="paramChart04.searchTicker = $event.value.toUpperCase()"
                    @selected-from-box="changeSymbol($event, 'paramChart04')"
                    @clear_field="clearField('paramChart04')"
                    @close="paramChart04.searchTicker = paramChart04.ticker"
                  />
                  <portfolio-select-timeframe-component
                    :ticker="paramChart04.ticker"
                    :timeframe="paramChart04.timeframe"
                    @change="changeTimeframe($event, 'paramChart04')"
                  />
                </div>
              </div>
            </adjustment-chart-component>
            <portfolio-chart-grid-component
              :ticker="paramChart04.ticker"
              :timeframe="paramChart04.timeframe"
              :investmentId="paramChart04.investmentId"
              @contextUuid="setContextUuid($event, 'paramChart04')"
              :selectedStrategy="paramChart04.selectedStrategy"
            />
          </div>
        </div>
      </div>
    </template>
    <!--  -->

    <!--  -->
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { mapGetters, mapActions } from "vuex";
import PortfolioStrategyChartHeaderComponent from "../components/portfolio-strategy-chart-header.component.vue";
import PortfolioSelectTimeframeComponent from "../components/portfolio-select-timeframe.component.vue";
import PortfolioChartHeaderComponent from "../components/portfolio-chart-header.component.vue";
import OntickEditableSelectComponent from "../../../shared/components/basic/ontick-editable-select.component.vue";
import PortfolioChartGridComponent from "../components/portfolio-chart-grid.component.vue";
import AdjustmentChartComponent from "../components/adjustment-chart.component.vue";
import EventBus from "../../../shared/utils/event_bus";
// import Datafeed from "../datafeed";

const isMobile = () => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      ) ||
      /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(!window["safari"] || (typeof safari !== "undefined" && safari.pushNotification))
    )
      check = true;
  })(navigator.userAgent || navigator.vendor);

  return check;
};

export default {
  name: "portfolio-chart",
  components: {
    PortfolioStrategyChartHeaderComponent,
    PortfolioSelectTimeframeComponent,
    PortfolioChartHeaderComponent,
    OntickEditableSelectComponent,
    PortfolioChartGridComponent,
    AdjustmentChartComponent,
  },
  data() {
    return {
      // datafeed: Datafeed,
      availableSymbols: ["WINFUT", "WDOFUT", "CCMFUT", "BITFUT"],

      // Gráficos
      paramChart01: {},
      paramChart02: {},
      paramChart03: {},
      paramChart04: {},

      pageContext: uuidv4(),
      template: isMobile() ? 8 : 2,

      listContextUuid: [],
      // Apenas as estratégias do portfolio selecionado.
      portfolioStrategies: [],

      // WebSocket
      connectionStatus: {
        awaitingConnection: false,
        retries: 0,
        error: false,
      },

      // Usado para correção do Streamer.
      positions: [],

      // Botão de atualizar Markers
      btnUpdateMarkers: false,

      updateIcon: {
        active: `<svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
        disabled: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
      },
    };
  },
  computed: {
    ...mapGetters({
      getWebsocketIsConnected: "config/getWebsocketIsConnected",
      selectedAccount: "accountTypes/getSelectedAccount",
      strategies: "performance/getStrategies",
    }),
    hasParamChart() {
      if (this.template === 1) {
        return Object.keys(this.paramChart01).length > 0;
      }
      if (this.template === 2 || this.template === 8) {
        return Object.keys(this.paramChart01).length > 0 && Object.keys(this.paramChart02).length > 0;
      }
      if ([3, 4, 5, 6].includes(this.template)) {
        return (
          Object.keys(this.paramChart01).length > 0 &&
          Object.keys(this.paramChart02).length > 0 &&
          Object.keys(this.paramChart03).length > 0
        );
      }
      if (this.template === 7) {
        return (
          Object.keys(this.paramChart01).length > 0 &&
          Object.keys(this.paramChart02).length > 0 &&
          Object.keys(this.paramChart03).length > 0 &&
          Object.keys(this.paramChart04).length > 0
        );
      }
      return false;
    },
    hasPortfolioInAccount() {
      if (Object.keys(this.strategies).length > 0 && this.strategies.accounts.length > 0) {
        const portfolioId = Number.parseInt(this.$route.query.portfolioId || 0, 10);
        const hasStrategy = this.strategies.accounts[0].investments.some(
          (inv) => Number.parseInt(inv.investment_id, 10) === portfolioId
        );

        // if (hasStrategy) {
        //   this.$nextTick(() => {
        //     this.initChart();
        //     this.widget?.onChartReady(() => {
        //       this.loadVolume();
        //       this.loadChartStyle();
        //       this.renameDisplayTimeframe();
        //     });
        //   });
        // }
        return hasStrategy;
      }
      return false;
    },
    topics() {
      let topics = [];
      this.positions.forEach((pos) => {
        if (["PORTFOLIO", "MULTISYMBOL"].includes(pos.type)) {
          pos.curr_positions.forEach((curr) => {
            topics.push(curr.position_symbol);
          });
        } else {
          topics.push(pos.position_symbol);
        }
      });
      return Array(...new Set(topics)).map((symbol) => `MD.${symbol}.L1`);
    },
  },
  watch: {
    template: {
      deep: true,
      handler(value) {
        this.resetGridParams();
        setTimeout(() => this.setGridParams(this.portfolioStrategies), 500);
        return value;
      },
    },
    selectedAccount: {
      deep: true,
      async handler(value) {
        await this.fetchAccounts(value);
        if (this.selectedAccount.account_id) {
          this.getRealTime(this.selectedAccount.account_id)
            .then(({ orders, positions }) => {
              // this.orders = orders;
              this.positions = positions;
            })
            .catch((err) => {
              console.error(err);
            });
        }
        return value;
      },
    },
  },
  created() {
    const scriptURL = "tradingview/charting_library/charting_library.standalone.js"; // Substitua pelo caminho correto
    if (!this.isScriptLoaded(scriptURL)) {
      this.addScript(scriptURL, () => {});
    }
  },
  async mounted() {
    if (Object.keys(this.selectedAccount).length > 0) {
      await this.fetchAccounts(this.selectedAccount);
      if (this.selectedAccount.account_id) {
        this.getRealTime(this.selectedAccount.account_id)
          .then(({ orders, positions }) => {
            this.orders = orders;
            this.positions = positions;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }

    // Parar com efeito de loading do botão btnUpdateMarkers.
    EventBus.$on("STOP_BTN_UPDATE_MARKERS", () => (this.btnUpdateMarkers = false));

    EventBus.$on("RESTART_CONSUMER", (isEmpty) => {
      // this.logEvent("[PORTFOLIO] RESTART_CONSUMER - mounted");
      this.consume(isEmpty);
      // this.updateAllMarkers();
    });
    EventBus.$on("MARKET_DATA", ({ symbol, data }) => {
      if (data.timeframe != "L1") {
        EventBus.$emit("REALTIME_TO_PORTFOLIO_CHART_GRID", { symbol, data });
      }
    });

    setTimeout(() => {});
  },
  destroyed() {
    this.worker.sendMessage({ type: "STOP_CONSUMING", data: this.pageContext });
    // this.listContextUuid.forEach(({ ctx }) => {
    //   this.worker.sendMessage({
    //     type: "STOP_CONSUMING",
    //     data: ctx,
    //   });
    // });
  },
  methods: {
    ...mapActions({
      fetchAccounts: "performance/fetchAccounts",
    }),
    isScriptLoaded(scriptSrc) {
      const scripts = document.head.getElementsByTagName("script");
      return Array.from(scripts).some((item) => item.src.includes(scriptSrc));
    },
    addScript(url, callback) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;

      script.onload = function () {
        if (callback) {
          callback();
        }
      };

      script.onerror = function () {
        console.error("Erro ao carregar o script: " + url);
      };

      document.head.appendChild(script);
    },
    listInvestment(portfolio) {
      // this.logTitle("listInvestment");
      if (Number(portfolio.investment_id) != 0) {
        if (Number(portfolio.investment_id) != Number(this.$route.query.portfolioId)) {
          this.$router.replace({ name: "PortfolioChart", query: { portfolioId: portfolio.investment_id } });
        }
        this.portfolioStrategies = portfolio.strategies;
        this.setGridParams(portfolio.strategies);
        this.consume();
      }
    },
    listInvestmentStrategy(strategy, paramChart) {
      let stratIndex = 0;

      if (paramChart === "paramChart02") stratIndex = 1;
      if (paramChart === "paramChart03") stratIndex = 2;
      if (paramChart === "paramChart04") stratIndex = 3;

      const params = strategy.investment_id === 0 ? this.portfolioStrategies[stratIndex] : strategy;

      // Obs.: se marcar "Selecione uma estratégia" então o investment_id == 0
      if (paramChart === "paramChart01") this.setParamChart("paramChart01", params);
      if (paramChart === "paramChart02") this.setParamChart("paramChart02", params);
      if (paramChart === "paramChart03") this.setParamChart("paramChart03", params);
      if (paramChart === "paramChart04") this.setParamChart("paramChart04", params);

      // this.updateAllMarkers();
    },
    setParamChart(paramChart, item, resetToggle = false) {
      if (paramChart === "paramChart01") {
        this.paramChart01 = {
          investmentId: Number(item.investment_id),
          ticker: item.investment_symbol,
          searchTicker: item.investment_symbol,
          // timeframe: item.investment_timeframe,
          timeframe: "M10",
          toggleConfig: resetToggle ? true : Boolean(this.paramChart01.toggleConfig),
          selectedStrategy: item,
        };
      }
      if (paramChart === "paramChart02") {
        this.paramChart02 = {
          investmentId: Number(item.investment_id),
          ticker: item.investment_symbol,
          searchTicker: item.investment_symbol,
          // timeframe: item.investment_timeframe,
          timeframe: "M10",
          toggleConfig: resetToggle ? true : Boolean(this.paramChart02.toggleConfig),
          selectedStrategy: item,
        };
      }
      if (paramChart === "paramChart03") {
        this.paramChart03 = {
          investmentId: Number(item.investment_id),
          ticker: item.investment_symbol,
          searchTicker: item.investment_symbol,
          // timeframe: item.investment_timeframe,
          timeframe: "M10",
          toggleConfig: resetToggle ? true : Boolean(this.paramChart03.toggleConfig),
          selectedStrategy: item,
        };
      }
      if (paramChart === "paramChart04") {
        this.paramChart04 = {
          investmentId: Number(item.investment_id),
          ticker: item.investment_symbol,
          searchTicker: item.investment_symbol,
          // timeframe: item.investment_timeframe,
          timeframe: "M10",
          toggleConfig: resetToggle ? true : Boolean(this.paramChart04.toggleConfig),
          selectedStrategy: item,
        };
      }
    },
    resetGridParams() {
      this.paramChart01 = {};
      this.paramChart02 = {};
      this.paramChart03 = {};
      this.paramChart04 = {};
    },
    setGridParams(strategies) {
      if (this.template === 1) {
        if (strategies.length >= 1) {
          this.paramChart01 = {
            investmentId: Number(strategies[0].investment_id),
            ticker: strategies[0].investment_symbol,
            searchTicker: strategies[0].investment_symbol,
            // timeframe: strategies[0].investment_timeframe,
            timeframe: "M10",
            toggleConfig: false,
            selectedStrategy: strategies[0],
          };
          this.paramChart02 = {};
          this.paramChart03 = {};
          this.paramChart04 = {};
        }
      }

      if (this.template === 2 || this.template === 8) {
        if (strategies.length >= 2) {
          this.paramChart01 = {
            investmentId: Number(strategies[0].investment_id),
            ticker: strategies[0].investment_symbol,
            searchTicker: strategies[0].investment_symbol,
            // timeframe: strategies[0].investment_timeframe,
            timeframe: "M10",
            toggleConfig: false,
            selectedStrategy: strategies[0],
          };
          this.paramChart02 = {
            investmentId: Number(strategies[1].investment_id),
            ticker: strategies[1].investment_symbol,
            searchTicker: strategies[1].investment_symbol,
            // timeframe: strategies[1].investment_timeframe,
            timeframe: "M10",
            toggleConfig: false,
            selectedStrategy: strategies[1],
          };
          this.paramChart03 = {};
          this.paramChart04 = {};
        }
      }

      if ([3, 4, 5, 6].includes(this.template)) {
        if (strategies.length >= 3) {
          this.paramChart01 = {
            investmentId: Number(strategies[0].investment_id),
            ticker: strategies[0].investment_symbol,
            searchTicker: strategies[0].investment_symbol,
            // timeframe: strategies[0].investment_timeframe,
            timeframe: "M10",
            toggleConfig: false,
            selectedStrategy: strategies[0],
          };
          this.paramChart02 = {
            investmentId: Number(strategies[1].investment_id),
            ticker: strategies[1].investment_symbol,
            searchTicker: strategies[1].investment_symbol,
            // timeframe: strategies[1].investment_timeframe,
            timeframe: "M10",
            toggleConfig: false,
            selectedStrategy: strategies[1],
          };
          this.paramChart03 = {
            investmentId: Number(strategies[2].investment_id),
            ticker: strategies[2].investment_symbol,
            searchTicker: strategies[2].investment_symbol,
            // timeframe: strategies[2].investment_timeframe,
            timeframe: "M10",
            toggleConfig: false,
            selectedStrategy: strategies[2],
          };
          this.paramChart04 = {};
        }
      }

      if (this.template === 7) {
        if (strategies.length >= 4) {
          this.paramChart01 = {
            investmentId: Number(strategies[0].investment_id),
            ticker: strategies[0].investment_symbol,
            searchTicker: strategies[0].investment_symbol,
            // timeframe: strategies[0].investment_timeframe,
            timeframe: "M10",
            toggleConfig: false,
            selectedStrategy: strategies[0],
          };
          this.paramChart02 = {
            investmentId: Number(strategies[1].investment_id),
            ticker: strategies[1].investment_symbol,
            searchTicker: strategies[1].investment_symbol,
            // timeframe: strategies[1].investment_timeframe,
            timeframe: "M10",
            toggleConfig: false,
            selectedStrategy: strategies[1],
          };
          this.paramChart03 = {
            investmentId: Number(strategies[2].investment_id),
            ticker: strategies[2].investment_symbol,
            searchTicker: strategies[2].investment_symbol,
            // timeframe: strategies[2].investment_timeframe,
            timeframe: "M10",
            toggleConfig: false,
            selectedStrategy: strategies[2],
          };
          this.paramChart04 = {
            investmentId: Number(strategies[3].investment_id),
            ticker: strategies[3].investment_symbol,
            searchTicker: strategies[3].investment_symbol,
            // timeframe: strategies[3].investment_timeframe,
            timeframe: "M10",
            toggleConfig: false,
            selectedStrategy: strategies[3],
          };
        }
      }
    },
    changeTimeframe(timeframe, paramChart) {
      if (paramChart === "paramChart01") {
        this.paramChart01.timeframe = timeframe;
      }
      if (paramChart === "paramChart02") {
        this.paramChart02.timeframe = timeframe;
      }
      if (paramChart === "paramChart03") {
        this.paramChart03.timeframe = timeframe;
      }
      if (paramChart === "paramChart04") {
        this.paramChart04.timeframe = timeframe;
      }
    },
    changeSymbol(symbol, paramChart) {
      if (paramChart === "paramChart01") {
        this.paramChart01.ticker = symbol;
        this.paramChart01.searchTicker = symbol;
        // Para CCMFUT e BITFUT, só tem timeframe M1 e M15.
        if (["CCMFUT", "BITFUT"].includes(symbol)) {
          if (!["M1", "M15"].includes(this.paramChart01.timeframe)) {
            this.paramChart01.timeframe = "M15";
          }
        }
      }
      if (paramChart === "paramChart02") {
        this.paramChart02.ticker = symbol;
        this.paramChart02.searchTicker = symbol;
        // Para CCMFUT e BITFUT, só tem timeframe M1 e M15.
        if (["CCMFUT", "BITFUT"].includes(symbol)) {
          if (!["M1", "M15"].includes(this.paramChart02.timeframe)) {
            this.paramChart02.timeframe = "M15";
          }
        }
      }
      if (paramChart === "paramChart03") {
        this.paramChart03.ticker = symbol;
        this.paramChart03.searchTicker = symbol;
        // Para CCMFUT e BITFUT, só tem timeframe M1 e M15.
        if (["CCMFUT", "BITFUT"].includes(symbol)) {
          if (!["M1", "M15"].includes(this.paramChart03.timeframe)) {
            this.paramChart03.timeframe = "M15";
          }
        }
      }
      if (paramChart === "paramChart04") {
        this.paramChart04.ticker = symbol;
        this.paramChart04.searchTicker = symbol;
        // Para CCMFUT e BITFUT, só tem timeframe M1 e M15.
        if (["CCMFUT", "BITFUT"].includes(symbol)) {
          if (!["M1", "M15"].includes(this.paramChart04.timeframe)) {
            this.paramChart04.timeframe = "M15";
          }
        }
      }
    },
    clearField(paramChart) {
      if (paramChart === "paramChart01") {
        this.paramChart01.searchTicker = "";
      }
      if (paramChart === "paramChart02") {
        this.paramChart02.searchTicker = "";
      }
      if (paramChart === "paramChart03") {
        this.paramChart03.searchTicker = "";
      }
      if (paramChart === "paramChart04") {
        this.paramChart04.searchTicker = "";
      }
    },
    consume(isEmpty = false) {
      // Parar de consumir no contexto "pageContext".
      this.worker.sendMessage({ type: "STOP_CONSUMING", data: this.pageContext });

      if (this.connectionStatus.retries > 5) {
        this.connectionStatus.error = true;
        this.connectionStatus.awaitingConnection = false;
        console.error("[ADMIN] Erro ao conectar ao websocket.");
        return;
      }
      if (!this.getWebsocketIsConnected) {
        if (this.isSharedWorker) {
          this.worker.sendMessage({ type: "CHECK_CONNECTION" });
        }
        this.connectionStatus.retries++;
        this.connectionStatus.awaitingConnection = true;
        setTimeout(() => {
          this.consume();
        }, 2000);
        return;
      }
      this.connectionStatus.awaitingConnection = false;
      this.connectionStatus.error = false;

      let arrayTopicsMD = [];
      this.listContextUuid.forEach(({ ctx, paramChart }) => {
        let _symbol, _tf;

        if (paramChart === "paramChart01") {
          _symbol = this.paramChart01.ticker;
          _tf = this.paramChart01.timeframe;
        } else if (paramChart === "paramChart02") {
          _symbol = this.paramChart02.ticker;
          _tf = this.paramChart02.timeframe;
        } else if (paramChart === "paramChart03") {
          _symbol = this.paramChart03.ticker;
          _tf = this.paramChart03.timeframe;
        } else if (paramChart === "paramChart04") {
          _symbol = this.paramChart04.ticker;
          _tf = this.paramChart04.timeframe;
        }

        arrayTopicsMD.push(`MD.${_symbol}.${_tf}`);
      });

      this.worker.sendMessage({
        type: "CONSUME",
        data: {
          uuid: this.pageContext,
          // topics: !isEmpty ? [...this.topics, ...arrayTopicsMD] : [...this.topics],
          topics: this.removeDuplicateValues([...this.topics, ...arrayTopicsMD]),
          type: "Admin",
        },
      });
      this.worker.sendMessage({ type: "LOG" });
    },
    removeDuplicateValues(arrayTopics) {
      return arrayTopics.filter((item, pos, self) => self.indexOf(item) == pos);
    },
    setContextUuid(ctx, paramChart) {
      this.listContextUuid.push({
        ctx,
        paramChart,
      });
    },
    getRealTime(account) {
      return new Promise((resolve, reject) => {
        this.$api
          .get(`${this.$endpoint.REAL_TIME}/${account}`)
          .then((res) => {
            resolve({
              orders: res.data.orders,
              positions: res.data.positions,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateAllMarkers() {
      this.btnUpdateMarkers = true;
      EventBus.$emit("RESTART_MARKERS");
    },
    filterByPortfolioStrategies(strategies) {
      const currentPortfolio = strategies.accounts[0].investments.find(
        (strat) => Number(strat.investment_id) === Number(this.$route.query.portfolioId)
      );

      if (!currentPortfolio) return [];

      return currentPortfolio.strategies;
    },
    isLocalhost() {
      return Boolean(
        window.location.hostname === "localhost" ||
          // [::1] is the IPv6 localhost address.
          window.location.hostname === "[::1]" ||
          // 127.0.0.1/8 is considered localhost for IPv4.
          window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
      );
    },
    logTitle(message = "", color = "red") {
      if (this.isLocalhost()) {
        const inlineStyle = `font-size:28px;font-weight:bold;padding:5px 10px;color:white;background-color:${color}`;
        console.log("%c%s", inlineStyle, message);
      }
    },
    logEvent(msg) {
      if (this.isLocalhost()) {
        console.log(
          "%c[RECEIVED]<<<%s>>>",
          "font-size:18px;font-weight:bold;color:yellow;border:2px solid red;padding:8px;",
          msg
        );
      }
    },
    // Habilitar somente em "localhost"
    /*
    debugDatafeedInLocalhost() {
      EventBus.$emit("SHOW_CHANNEL_SUBSCRIPTION");
    },
    */
  },
};
</script>
